"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModeWidgetConfig = void 0;
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const upperFirst_1 = __importDefault(require("lodash/upperFirst"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const helpers_1 = require("../../../../utils/helpers");
const odHelpers = __importStar(require("../../../odSurvey/helpers"));
const segmentHelpers = __importStar(require("./helpers"));
const types_1 = require("../../../odSurvey/types");
const modeIconMapping_1 = require("./modeIconMapping");
const perModeConditionals = {
    wheelchair: segmentHelpers.conditionalPersonMayHaveDisability,
    mobilityScooter: segmentHelpers.conditionalPersonMayHaveDisability,
    paratransit: segmentHelpers.conditionalHhMayHaveDisability
};
/** TODO Get a segment config in parameter to set the sort order and choices */
const getModeChoices = (filteredModes) => filteredModes.map((mode) => ({
    value: mode,
    label: (t) => t([`customSurvey:segments:mode:${(0, upperFirst_1.default)(mode)}`, `segments:mode:${(0, upperFirst_1.default)(mode)}`]),
    conditional: function (interview, path) {
        const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
        if (segment !== null && segment.modePre) {
            if (!types_1.modePreToModeMap[segment.modePre].includes(mode)) {
                return false;
            }
        }
        // See if there's any additional conditional for the mode
        const conditional = perModeConditionals[mode];
        return conditional ? conditional(interview, path) : true;
    },
    iconPath: (0, modeIconMapping_1.getModeIcon)(mode)
}));
const getModeWidgetConfig = (
// FIXME: Type this when there is a few more widgets implemented
options = {}) => {
    // TODO Use a segment configuration to determine which modes should be
    // presented and in which order
    const filteredModes = segmentHelpers.getFilteredModes(options.segmentConfig);
    if (filteredModes.length === 0) {
        throw new Error('No available modes to create mode widget configuration');
    }
    const segmentModeChoices = getModeChoices(filteredModes);
    return {
        type: 'question',
        path: 'mode',
        inputType: 'radio',
        twoColumns: false,
        datatype: 'string',
        iconSize: '2.25em',
        columns: 2,
        label: (t) => {
            var _a;
            return t(['customSurvey:segments:ModeSpecify', 'segments:ModeSpecify'], {
                context: (_a = options.context) === null || _a === void 0 ? void 0 : _a.call(options)
            });
        },
        choices: segmentModeChoices,
        validations: function (value) {
            return [
                {
                    validation: (0, LodashExtensions_1._isBlank)(value),
                    errorMessage: (t) => t(['customSurvey:segments:ModeIsRequired', 'segments:ModeIsRequired'])
                }
            ];
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const shouldShowSameAsReverseTrip = segmentHelpers.shouldShowSameAsReverseTripQuestion({
                interview,
                segment
            });
            // Do not show if the question of the same mode as previous trip is shown and the answer is not 'no'
            if (shouldShowSameAsReverseTrip && segment.sameModeAsReverseTrip !== false) {
                if (segment.sameModeAsReverseTrip === true) {
                    // If the question of the same mode as previous trip is shown and the answer is yes, the mode is the same as the previous trip
                    const previousTripSegment = segmentHelpers.getPreviousTripSingleSegment({
                        interview,
                        person: odHelpers.getActivePerson({ interview })
                    });
                    if (previousTripSegment && previousTripSegment.mode !== undefined) {
                        return [false, previousTripSegment.mode];
                    }
                }
                // Otherwise, initialize to null
                return [false, null];
            }
            // Make sure modePre is selected before displaying
            const modePre = segment ? segment.modePre : null;
            if ((0, LodashExtensions_1._isBlank)(modePre)) {
                return [false, null];
            }
            // Check if there is more than one choice available for this trip
            const modes = segmentModeChoices.filter((choice) => choice.conditional(interview, path) === true);
            if (modes.length === 1 || modes.length === 0) {
                return [false, modes[0] ? modes[0].value : modePre];
            }
            return [true, null];
        }
    };
};
exports.getModeWidgetConfig = getModeWidgetConfig;
//# sourceMappingURL=widgetSegmentMode.js.map